import {useContext} from 'react';

import {
  AbstractDecisionTreeContextType,
  useAbstractDecisionTree,
} from '../../../../../libs/shared/ui/src/components/decisionTrees/decisionTreeBuilder/abstractDecisionTreeContext';
import {ChatBotBuilderContext, ChatBotBuilderContextType} from '../chatBotBuilderContext';
import {ChatBotBuilderNodeData} from '../types';

/*
 * Types.
 */

interface UseChatBotBuilderType {
  abstractDecisionTree: AbstractDecisionTreeContextType<ChatBotBuilderNodeData>;
  chatBotBuilderContext: ChatBotBuilderContextType;
}

/*
 * Hooks.
 */

export function useChatBotBuilder(): UseChatBotBuilderType {
  const abstractDecisionTree = useAbstractDecisionTree<ChatBotBuilderNodeData>();
  const chatBotBuilderContext = useContext(ChatBotBuilderContext);

  if (!chatBotBuilderContext) {
    throw new Error('useChatBotBuilder must be used within a ChatBotBuilderContext.Provider');
  }

  return {
    abstractDecisionTree,
    chatBotBuilderContext,
  };
}
